import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

interface DrawerFooterProps {
  isBusy: boolean;
  onClose: () => void;
  sx?: SxProps<Theme>;
}

export default function DrawerFooter({ isBusy, onClose, sx }: DrawerFooterProps) {
  return (
    <Box
      sx={[
        (theme) => ({
          alignItems: 'center',
          borderTop: `solid 1px ${theme.palette.divider}`,
          display: 'flex',
          justifyContent: 'flex-end',
          px: 3,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <SmallButton
        color="inherit"
        disabled={isBusy}
        onClick={onClose}
        variant="outlined"
        sx={(theme) => ({
          bgcolor: theme.semantic.surfaceRaised,
          border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
        })}
      >
        {t('actions.close')}
      </SmallButton>
    </Box>
  );
}
